const YAxisLabel = props => {
  const { viewBox, value, angle, position, offset } = props
  const { x, y, height, width } = viewBox
  const currentPos = {
    x: x + width / 2 + (position === 'left' ? offset * -1 : offset),
    y: y + height / 2
  }

  return (
    <g
      transform={`translate(${currentPos.x},${currentPos.y}) rotate(${angle})`}
    >
      <text
        dy={-4}
        fill='#979ba7'
        fontSize={12}
        textAnchor='middle'
      >
        {value}
      </text>
    </g>
  )
}

export default YAxisLabel
